(() => {
  const init = (root) => {
    if (!root || root.dataset.rpmReady === '1') return;
    root.dataset.rpmReady = '1';

    if (root.classList.contains('is-static')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('is-static');
      return;
    }

    const isMobile = () => window.matchMedia('(max-width: 768px)').matches;
    const image = () =>
      isMobile()
        ? root.querySelector('.rpm__img--mobile') || root.querySelector('.rpm__img--desktop')
        : root.querySelector('.rpm__img--desktop') || root.querySelector('.rpm__img--mobile');

    const reveals = root.querySelectorAll('[data-rpm-reveal]');
    const bars = root.querySelectorAll('[data-rpm-bar]');
    const baseScale = Number(root.dataset.baseScale || 0.66);
    const trigger = Number(root.dataset.trigger || 0.65);
    let currentScale = baseScale;
    let targetScale = baseScale;
    let rafId = 0;

    const clamp = (v, min, max) => Math.min(Math.max(v, min), max);

    const getVisibleRatio = (img) => {
      if (!img) return 0;
      const rect = img.getBoundingClientRect();
      const vh = window.innerHeight || 1;
      const visibleTop = Math.max(rect.top, 0);
      const visibleBottom = Math.min(rect.bottom, vh);
      const visibleH = Math.max(0, visibleBottom - visibleTop);
      if (isMobile()) {
        return clamp(visibleH / Math.max(rect.height, 1), 0, 1);
      }
      return clamp(visibleH / vh, 0, 2);
    };

    const calcScale = (ratio) => {
      if (ratio >= trigger) return 1;
      const p = clamp(ratio / trigger, 0, 1);
      const eased = 1 - Math.pow(1 - p, 3);
      return baseScale + (1 - baseScale) * eased;
    };

    const setReveal = (on) => {
      reveals.forEach((el) => el.classList.toggle('is-visible', on));
      bars.forEach((el) => el.classList.toggle('is-visible', on));
    };

    const update = () => {
      const img = image();
      if (!img) return;

      const sectionRect = root.getBoundingClientRect();
      const ratio = getVisibleRatio(img);

      if (sectionRect.top <= 0) {
        targetScale = 1;
      } else {
        targetScale = calcScale(ratio);
      }

      if (sectionRect.top <= 0) return;
      setReveal(ratio >= trigger);
    };

    const animate = () => {
      const img = image();
      if (img && !isMobile()) {
        currentScale += (targetScale - currentScale) * 0.12;
        const translateY = -(currentScale - baseScale) * 40;
        img.style.transform = `scale(${currentScale}) translateY(${translateY}px)`;
      } else if (img) {
        img.style.transform = '';
      }
      rafId = requestAnimationFrame(animate);
    };

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    const img = image();
    if (img && img.complete) update();
    else if (img) img.addEventListener('load', update, { once: true });
    else update();

    rafId = requestAnimationFrame(animate);

    root.addEventListener(
      'shopify:section:unload',
      () => {
        cancelAnimationFrame(rafId);
        window.removeEventListener('scroll', update);
        window.removeEventListener('resize', update);
      },
      { once: true }
    );
  };

  const boot = () => {
    document.querySelectorAll('[data-rpm-root]').forEach(init);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-rpm-root]');
    if (root) {
      delete root.dataset.rpmReady;
      init(root);
    }
  });
})();
